interface ILaasFaqItem {
    id?: string;
    question: string;
    answer: JSX.Element | null;
}

export const faqItems: ILaasFaqItem[] = [
    {
        question: 'How do I get my vehicle shipped?',
        answer: (
            <p>
                Once you get a quote, fill out your shipping details. An associate will reach out to you to schedule
                your auto transport and provide shipping details. You can also call us directly at{' '}
                <a href="tel:18339501954">(833) 950-1954</a> to schedule your shipping. Timing is subject to truck
                availability.
            </p>
        ),
    },
    {
        question: 'Who do we serve?',
        answer: (
            <p>
                We offer vehicle shipping service for a variety of reasons, including relocation, college, seasonal
                travelers, military and CarMax auction transport.
            </p>
        ),
    },
    {
        question: 'How much does is cost to ship my vehicle?',
        answer: (
            <p>
                Rates can vary depending on shipping routes, so please use route picker to get specific route prices.
                What&apos;s different between us and a lot of other companies, is that our shipping rates are based on
                distance ONLY—not distance and size—and does not fluctuate based on busy seasons.
            </p>
        ),
    },
    {
        question: 'What vehicles cannot be shipped?',
        answer: <p>Please note that CarMax cannot ship inoperable vehicles, oversized vehicles, or motorcycles.</p>,
    },
    {
        question: 'Can I put anything in the vehicle to ship with it?',
        answer: (
            <p>
                No, you can&apos;t include personal items in your vehicle. However, you don&apos;t need to remove items
                that typically remain in vehicles (safety kits, spare tire, vehicle registration, etc.). Car seats that
                are properly secured in position by the LATCH system or seatbelt may be transported. CarMax is not
                responsible for any loss or damage to items left in the vehicle.
            </p>
        ),
    },
    {
        question: 'How do I prepare to drop off my vehicle?',
        answer: (
            <p>
                Your vehicle must be empty and must have at least a <sup>1</sup>&frasl;<sub>4</sub> tank of gas when it
                is dropped off.
            </p>
        ),
    },
    {
        question: 'What do I need to bring with me when I drop off my vehicle?',
        answer: (
            <p>
                You&apos;ll need to bring your vehicle&apos;s valid registration, a valid driver&apos;s license to the
                drop-off, and a payment method if you have not already paid your shipping rate. You must be the
                registered owner of the vehicle in order to ship it.
            </p>
        ),
    },
    {
        question: 'Where can I drop off / ship my vehicle?',
        answer: (
            <p>
                Select from participating CarMax locations within the following states: Arizona, Connecticut, Delaware,
                Florida, Massachusetts, Maryland, Minnesota, New Jersey, Virginia, and Wisconsin.
            </p>
        ),
    },
    {
        question: 'How long does it take?',
        answer: (
            <p>
                Transit times are estimates based on when your vehicle is loaded on the truck for transport which could
                take 2-21 days. We&apos;ll reach out to you with an update in the event of any schedule changes. Payment
                is due when you drop your vehicle off at the CarMax drop-off location. **Note: If you&apos;re shipping
                from Virginia or Delaware you will need to pay ahead of dropping off your vehicle at the store. You have
                the option to pay the shipping rate over the phone before dropping off your vehicle by calling{' '}
                <a href="tel:18339501954">(833) 950-1954</a>.
            </p>
        ),
    },
    {
        question: 'Who can pick up my vehicle?',
        answer: (
            <p>
                You, or an individual you&apos;ve authorized to pick up your vehicle when you dropped it off, must pick
                up the vehicle at the scheduled CarMax pick-up location.
            </p>
        ),
    },
    {
        question: 'Will CarMax cover damage to my vehicle?',
        answer: (
            <p>
                Generally, CarMax will cover damage sustained during transportation as specified in the Terms and
                Conditions. However, certain types of damage wouldn&apos;t be covered by CarMax. For example, we
                wouldn&apos;t be responsible for any loss or damage to personal items left in the vehicle, or for damage
                resulting from acts of God like a hailstorm.
            </p>
        ),
    },
    {
        question: 'Where can I find a copy of the auction transportation T&Cs?',
        answer: (
            <p>
                Please review the CarMax Auction Transport{' '}
                <a href="/home/docs/auctions-bol-terms-and-conditions-for-business.pdf">Terms and Conditions</a> for
                more detail.
            </p>
        ),
    },
];
